var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8535534,5.64644661 C12.0488155,5.45118446 12.365398,5.45118446 12.5606602,5.64644661 C12.7342265,5.82001296 12.7535117,6.08943736 12.6185156,6.2843055 L12.5606602,6.35355339 L8.91410678,10 L12.5606602,13.6464466 C12.7342265,13.820013 12.7535117,14.0894374 12.6185156,14.2843055 L12.5606602,14.3535534 C12.3870938,14.5271197 12.1176694,14.5464049 11.9228013,14.4114088 L11.8535534,14.3535534 L7.5,10 L11.8535534,5.64644661 Z",
    id: "Path-3",
    fill: "#666666",
    fillRule: "nonzero",
    transform: "translate(10.103553, 10.000000) scale(-1, 1) rotate(-360.000000) translate(-10.103553, -10.000000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.632bfb592b066d1311d63eb93efbefef.svg";
export { ForwardRef as ReactComponent };